export default "__VITE_ASSET__ByLKS5oy__"